import { observable, reaction } from "mobx";
import { wordPressService } from "../../../../cdm/services/wordpress-service";
import { endpointConfig } from "../../../../config/api-config";
import { stateController } from "../../../../cdm/controllers/state-controller";

export class CaregiverEEListController {
  @observable loading = false;
  frameUrl = "";

  constructor(props) {
    this.props = props;
    this._initialize();
    reaction(() => stateController.viewGroupId, () => this._initialize());
  }

  _initialize = () => {
    wordPressService.setWpHostname(endpointConfig.job_posting_hostname);
    this.frameUrl = `${window.location.protocol}//${
      endpointConfig.job_posting_hostname
    }/jobs/senior-caregiver/matches?group=${
      stateController.viewGroupId
    }&hideHero=true&hideBody=true`;
  };
}
